/* unplugin-vue-components disabled */import { render } from "./CompleteOrder.vue?vue&type=template&id=20eaa8bf&scoped=true&ts=true"
import script from "./CompleteOrder.vue?vue&type=script&lang=ts"
export * from "./CompleteOrder.vue?vue&type=script&lang=ts"

import "./CompleteOrder.vue?vue&type=style&index=0&id=20eaa8bf&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20eaa8bf"]])

export default __exports__